import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "grey--text caption"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pa-0 ma-0" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDialog()))
      }, [
        (_ctx.button)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              size: "x-small",
              elevation: "0",
              icon: "$fa-university"
            }))
          : (_openBlock(), _createBlock(_component_v_select, {
              key: 1,
              modelValue: _ctx.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
              items: _ctx.activities,
              attach: "",
              chips: "",
              "return-object": "",
              label: _ctx.label,
              multiple: "",
              disabled: "",
              "hide-details": _ctx.hideDetails,
              density: "compact",
              "item-title": (item) => item.name
            }, {
              selection: _withCtx(({ item, index }) => [
                (index < 3)
                  ? (_openBlock(), _createBlock(_component_v_chip, { key: 0 }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (index === 3)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(+" + _toDisplayString(_ctx.value.length - 3) + " others)", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "items", "label", "hide-details", "item-title"]))
      ]),
      (_ctx.dialogActivitySelection)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 0,
            onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.dialogActivitySelection = false), ["esc"])),
            modelValue: _ctx.dialogActivitySelection,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogActivitySelection) = $event)),
            "min-width": !_ctx.$vuetify.display.mobile ? '500px' : undefined,
            "max-width": !_ctx.$vuetify.display.mobile ? '600px' : undefined,
            "min-height": !_ctx.$vuetify.display.mobile ? '600px' : undefined,
            fullscreen: _ctx.$vuetify.display.mobile,
            "hide-overlay": _ctx.$vuetify.display.mobile,
            title: 'Sélectionnez un code NAF'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "pt-3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.activitySearch,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activitySearch) = $event)),
                    label: "Recherche",
                    autofocus: "",
                    density: "compact"
                  }, null, 8, ["modelValue"]),
                  (_ctx.multiple)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": "",
                        class: "py-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "6",
                            class: "d-flex justify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                size: "small",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectAll()))
                              }, {
                                default: _withCtx(() => [
                                  _cache[8] || (_cache[8] = _createTextVNode(" Tout sélectionner ")),
                                  _createVNode(_component_v_icon, { right: "" }, {
                                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                                      _createTextVNode("$check_box")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "6",
                            class: "d-flex justify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                size: "small",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearAll()))
                              }, {
                                default: _withCtx(() => [
                                  _cache[10] || (_cache[10] = _createTextVNode(" Tout désélectionner ")),
                                  _createVNode(_component_v_icon, { right: "" }, {
                                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                                      _createTextVNode("$check_box_outline_blank")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_virtual_scroll, {
                        "item-height": 84,
                        items: _ctx.activities,
                        height: "300"
                      }, {
                        default: _withCtx(({ item }) => [
                          (_openBlock(), _createBlock(_component_v_list_item, {
                            key: item.id,
                            onClick: ($event: any) => (_ctx.isAdd(item)),
                            class: "oss-list-item mb-2"
                          }, {
                            append: _withCtx(() => [
                              (_ctx.isSelected(item))
                                ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.multiple ? "$check_box" : "$radio_button_checked"), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.multiple
                                                ? "$check_box_outline_blank"
                                                : "$radio_button_unchecked"), 1)
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getActivityName(item)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_list_item_subtitle, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.description), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        ]),
                        _: 1
                      }, 8, ["items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "min-width", "max-width", "min-height", "fullscreen", "hide-overlay"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}